import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class BillingDataService {
  private storeBankAccount = "";
  private storeBankAccountSource = new BehaviorSubject<any>(
    this.storeBankAccount
  );
  $storeBankAccount = this.storeBankAccountSource.asObservable();
  billingDetails: any  = {};
  private messageSource = new BehaviorSubject<any>(this.billingDetails);
  $billingDetails = this.messageSource.asObservable();
  billingDetailsEcheck: any = {};
  private messageSourceEcheck = new BehaviorSubject<any>(
    this.billingDetailsEcheck
  );
  $billingDetailsEcheck = this.messageSourceEcheck.asObservable();

  clearBilling(): void {
    this.messageSource.next(this.billingDetails);
  }

  updateBillingDetails(currentBill: any) {
    this.messageSource.next(currentBill);
  }

  updateBillingDetailsEcheck(currentBill: any) {
    this.messageSourceEcheck.next(currentBill);
  }

  updateBankAccountCheck(storeBankAccount) {
    this.storeBankAccountSource.next(storeBankAccount);
  }

  clearCheckingAccount() {
    this.messageSourceEcheck.next('');
  }
}
